import { Center, Loader } from "@mantine/core";

export function RouteFallback() {
  return (
    <Center mih="50vh" role="status" aria-live="polite">
      <Loader type="dots" />
    </Center>
  );
}
